import avatar from './icon-avatar.png';
import bookings from './icon-bookings.png';
import campaigns from './icon-campaigns.png';
import download from './icon-download.png';
import info from './icon-info.png';
import invoices from './icon-invoices.png';
import menu from './icon-menu.png';
import stats from './icon-stats.png';
import wizard from './icon-wizard.png';

export default {
  avatar,
  bookings,
  campaigns,
  download,
  info,
  invoices,
  menu,
  stats,
  wizard,
};
